export const bannerLayoutLeftBlockFixedSize = 434;
export const bannerLayoutLeftRecommendedBlockFixedSize = 336;
